module.exports = __webpack_public_path__ + "static/media/Grover Cleveland - 1892.8d5e3e53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Grover Cleveland - 1892.jpg
// module id = 482
// module chunks = 0